import { SakerSide } from '../innboks/SakerSide.tsx';
import { InnstillingerSide } from '../innstillinger/InnstillingerSide.tsx';
import { KjenteFeilSide } from '../kjentefeil/KjenteFeilSide.tsx';
import { OrganisasjonSide } from '../organisasjon/OrganisasjonSide.tsx';
import { ListeSide } from '../organisasjon/panelbrukere/ListeSide.tsx';
import { NySide } from '../organisasjon/panelbrukere/NySide.tsx';
import { PersonSide } from '../organisasjon/panelbrukere/PersonSide.tsx';
import { ProgrammerSide } from '../programmer/ProgrammerSide.tsx';

/**
 * De fem sidene i rommet Innspill (DD-01). Innboks og Saker er innboksen fra M2.2 (samme
 * komponent, to moduser), Kjente feil er registeret fra M2.4, Innstillinger er flaten fra
 * M2.5, og Betaprogram er programmet fra M3.1 (siden heter det i skallet — komponenten
 * og stien er fortsatt «programmer», P6).
 *
 * Organisasjon er ikke en av dem: den ligger utenfor rommene og bare for eier (R4.3).
 */
export function Innboks() {
  return <SakerSide modus="innboks" />;
}

export function Saker() {
  return <SakerSide modus="saker" />;
}

export function Programmer() {
  return <ProgrammerSide />;
}

export function KjenteFeil() {
  return <KjenteFeilSide />;
}

export function Innstillinger() {
  return <InnstillingerSide />;
}

export function Organisasjon() {
  return <OrganisasjonSide />;
}

/** Panelbrukere under Organisasjon (M4.8 steg 3): lista, personen og «Legg til person». */
export function Panelbrukere() {
  return <ListeSide />;
}

export function Panelbruker() {
  return <PersonSide />;
}

export function NyPanelbruker() {
  return <NySide />;
}
